import { clearEncryptionCache } from './caching.js';
import { getCloudPublicKey } from './keys.js';
import { toastErrorAndReport } from '../../functions/toast/toast.js';
import { getStore } from '../../store/helpers/initStore.js';

/**
 * Initialize a user's access to encrypt data and set AuthStatus to COMPLETE
 */
const initializeEncryptionAccess = async () => {
    const store = getStore();
    try {
        await getCloudPublicKey();
        store.commit('auth/SET_ENCRYPTION_ACCESS', true);
    }
    catch (error) {
        toastErrorAndReport('There was a problem while initializing encryption access.');
    }
    store.commit('auth/SET_AUTH_LOADING', false);
};
/**
 * Clear all encryption related data from cache
 */
const deinitializeEncryptionAccess = () => {
    const store = getStore();
    clearEncryptionCache();
    if (store.state.auth.user !== undefined) {
        store.commit('auth/SET_ENCRYPTION_ACCESS', false);
    }
    else {
        store.commit('auth/SET_AUTH_LOADING', false);
    }
};

export { deinitializeEncryptionAccess, initializeEncryptionAccess };
